class PdpEngravingHelper {
    constructor(config, isGold, productImages) {
        this.config = config;
        this.isGold = isGold;
        this.productImages = productImages;
        this.myCanvas = false;
        this.areaData = {};
        this.init();
        this.attachEvents();
    }
    //Init start
    init() {
          const { img_position, area, general, options: { initials_c1_set1, initials_c1_set2, initials, monogram, name_c12, phrases, dates, symbols } } = this.config;

        //console.log('Test 321');
        $('.prod-large-img').parent().prepend('<canvas id="myCanvas" height="500" width="500" class="engraving-preview"></canvas>');
        console.log(initials);
        console.log(monogram);
        this.areaData = this.config.area;
        console.log('Applied Config:');
        console.log(this.config);

        console.log('--Engraving Image: Define');
        let imgSrc = this.config.img_position;
        this.engraving_product_img = '';
        console.log(imgSrc);
        console.log(this.config.general[0]);
        let engravingImgData = this.productImages[imgSrc-1] ? this.productImages[imgSrc-1] : false;
        if (!engravingImgData) {
            console.log('Engraving Error: ' + 'Preview image is not found');
            return;
        }
        console.log(engravingImgData);
        //resize
        this.engraving_product_img = theme.Images.getSizedImageUrl(engravingImgData.src, '500x');
        console.log('Resized');
        console.log(this.engraving_product_img);
        console.log('--Engraving Image: End');

        let options = this.config.options;
        console.log("CONFIG OPTIONS", this.config.options);

        this.oneCharFont1 = '';
        this.oneCharFont2 = '';
        this.threeCharFont = '';
        this.monogramFontSize = monogram ? monogram["font-size"] : 0;
        this.phraseFont = '';
        this.datesFont = '';
        this.symbolsFontSize = symbols ?`${symbols["font-size"]}`:0;
        this.nameFont = '';
        this.nameFontSize = name_c12 ? name_c12["font-size"] : 0;

        this.imgDim = {
            width: this.symbolsFontSize,
            height: this.symbolsFontSize
        };
        this.threeCharFontSize = 0;

        console.log('---------------ENGRAVING OPTIONS--------------');


        if (typeof initials === 'undefined' && typeof monogram === 'undefined') {
            console.log('not found:INITIALS');
            console.log('not found:Monogram');
            $('ul.engraving-options-list li:has(input#initials)').hide();
            $('ul.engraving-options-list li:has(input#initials) input#initials').prop('checked', false);
            $('ul.engraving-options-list li:has(input#sdj) input#sdj').prop('checked', false);
            console.log("LENGTH OF INITIALS",$('.engraving-item[data-id="initials"]').length);
            console.log('----------------------------------------------');
            //check for monogram
        }
        else if (typeof initials === 'undefined' && typeof monogram !== 'undefined') {
            console.log('found:Monogram');
            console.log('not found:INITIALS');
            $('#initials-options li').each(function( index ) {
                //console.log( index + ": " + $(this).find('input').attr('id'));
                const id = $(this).find('input').attr('id');
                if (id != 'sdj-custom') {
                    $(this).hide();
                }
            });
            $('ul.engraving-options-list li:has(input#initials) input#initials').prop('checked', true);
            $('ul.engraving-options-list li:has(input#sdj-custom) input#sdj-custom').prop('checked', true);
            $('.engraving-item[data-id="initials"]').show();
            $('.engraving-item[data-id="sdj-custom"]').show();
            //data-id="sdj-custom"
        }
        else{
            console.log('found:INITIALS');
            $('ul.engraving-options-list li:has(input#initials) input#initials').prop('checked', true);
            $('ul.engraving-options-list li:has(input#sdj) input#sdj').prop('checked', true);
            $('.engraving-item[data-id="initials"]').show();
            $('.engraving-item[data-id="sdj"]').show();
            //check for monogram
            if (typeof monogram === 'undefined') {
                //hide monogram
                console.log('not found:Monogram');
                $('#sdj-custom').parent().remove();
            } else {
                console.log('found:Monogram');
            }
            console.log('----------------------------------------------');
        }

      if (typeof initials_c1_set1 === 'undefined' && typeof initials_c1_set2 === 'undefined' ) {
            console.log('not found:INITIALS_C1 or INITIALS_C1_SET 2');
            console.log('----------------------------------------------');
            $('ul.engraving-options-list li:has(input#font)').hide();
            $('ul.engraving-options-list li:has(input#font-2)').hide();

        } else if (typeof initials_c1_set1 === 'undefined' && typeof initials_c1_set2 !== 'undefined' ) {
                console.log('INITIALS_C1_SET2 found');
                $('.engraving-item[data-id="font-2"]').show();
                $('.engraving-item[data-id="font"]').hide();
                $('ul.engraving-options-list li:has(input#font)').hide();
                $('ul.engraving-options-list li:has(input#font-2) input#font-2').prop('checked', true);
                $('div[data-id="font-2"] ul.engraving-options-list').find('li:nth-child(1)').addClass('active');     
                console.log('----------------------------------------------');
                this.oneCharFont2 = options.initials_c1_set2["font-size"] + "px";
                console.log("ONE CHAR FONT SET 2 FONT SIZE "+this.oneCharFont2);
            
            } else if (typeof initials_c1_set1 !== 'undefined' && typeof initials_c1_set2 === 'undefined' ) {
                console.log('INITIALS_C1_SET1 found');
                $('.engraving-item[data-id="font"]').show();
                $('.engraving-item[data-id="font-2"]').hide();
                $('ul.engraving-options-list li:has(input#font-2)').hide();
                $('ul.engraving-options-list li:has(input#font) input#font').prop('checked', true);
                $('div[data-id="font"] ul.engraving-options-list').find('li:nth-child(1)').addClass('active');

                console.log('----------------------------------------------');
                this.oneCharFont1 = options.initials_c1_set1["font-size"] + "px";
                console.log("ONE CHAR FONT SET 1 FONT SIZE "+this.oneCharFont1);
        
            } else {
               console.log('INITIALS_C1_SET1 and INITIALS_C1_SET2 found');
                $('.engraving-item[data-id="font"]').show();
                $('.engraving-item[data-id="font-2"]').hide();
                $('ul.engraving-options-list li:has(input#font)').show();
                $('ul.engraving-options-list li:has(input#font-2)').show();
                $('ul.engraving-options-list li:has(input#font) input#font').prop('checked', true);
                $('div[data-id="font"] ul.engraving-options-list').find('li:nth-child(1)').addClass('active');

                console.log('----------------------------------------------');
                this.oneCharFont1 = options.initials_c1_set1["font-size"] + "px";
                this.oneCharFont2 = options.initials_c1_set2["font-size"] + "px";
        
            }
        

        if (typeof phrases === 'undefined') {
            console.log('not found:PHRASES');
            $('ul.engraving-options-list li:has(input#phrases)').hide();
            console.log('----------------------------------------------');
        } else {
            console.log('found:PHRASES');
            this.phraseFont = options.phrases["font-size"]+"px "+ options.phrases["font-family"];
            console.log('----------------------------------------------');

        }

        if (typeof dates === 'undefined') {
            console.log('not found:DATES');
            $('ul.engraving-options-list li:has(input#dates)').hide();
            console.log('----------------------------------------------');
        }else {
            console.log('found:DATES');
            this.datesFont = options.dates["font-size"]+"px "+ options.dates["font-family"];
            console.log('DATES - FONT --------', this.datesFont);
            console.log('----------------------------------------------');
        }

        if (typeof symbols === 'undefined') {
            console.log('not found:SYMBOLS');
            $('ul.engraving-options-list li:has(input#symbols)').hide();
            console.log('----------------------------------------------');
        }else {
            console.log('found:SYMBOLS');
            console.log('SYMBOLS - FONT SIZE --------', this.symbolsFontSize);
            console.log('----------------------------------------------');
        }

// Function to dynamically load a CSS file and return a promise
function loadCSSFile(href) {
    return new Promise((resolve, reject) => {
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = () => {
            console.log(`${href} has been loaded`);
            resolve();
        };
        link.onerror = () => {
            console.error(`Error loading CSS file: ${href}`);
            reject(new Error(`CSS file failed to load: ${href}`));
        };
        document.head.appendChild(link);
    });
}



if (typeof name_c12 === 'undefined') {
  
           $('.engraving-item[data-id="name-input"]').hide();
            $('ul.engraving-options-list li:has(input#name)').hide();
}else{
    console.log('NAME_C12 found');

    // Disable engraving options until fonts are fully loaded
    $('input[type=radio]').attr('disabled', true);  // Disable all engraving options

    // Load the Adobe font CSS files and check if fonts are ready
    Promise.all([
        loadCSSFile('https://use.typekit.net/wbx0rmi.css'), // Adobe Caslon Pro Bold
        loadCSSFile('https://use.typekit.net/ymb7ksn.css')  // Sanvito
    ]).then(() => {
        console.log('All CSS files loaded, waiting for fonts...');

        // Wait for all fonts to be fully loaded
        document.fonts.ready.then(() => {
           console.log('Fonts are fully loaded, enabling engraving options.');

            // Enable the engraving options now that fonts are ready
            $('input[type=radio]').attr('disabled', false);  // Re-enable all engraving options

            // Show the name input and continue rendering
            $('.engraving-item[data-id="name-input"]').show();
            $('.engraving-item[data-id="name-input"]').css('border-top', 'none');
            $('.engraving-item-container.engraving-style').css('display', 'none');
            // $('ul.engraving-options-list li:has(input#name)').show();
          
            $('ul.engraving-options-list li:has(input#name) input#name').prop('checked', true);
            $('div[data-id="name-input"] ul.engraving-options-list').find('li:nth-child(1)').addClass('active');
            
            this.nameFont = options.name_c12["font-size"] + "px " + options.name_c12["font-family"];
            console.log('NAME C12 - FONT --------', this.nameFont);

            // Proceed with your rendering logic
            // obj.render();  // Your rendering logic on the canvas
        }).catch((err) => {
            console.error("Error waiting for fonts to load:", err);
            $('input[type=radio]').attr('disabled', false);  // Ensure inputs are enabled even if there's an error
        });
    }).catch((err) => {
        console.error("Error loading CSS files:", err);
        $('input[type=radio]').attr('disabled', false);  // Ensure inputs are enabled even if there's an error
    });
}



        if (this.config.general[0] === 'c1') {
            console.log('AREA DATA --------', JSON.stringify(this.areaData));
            console.log('IMG POS --------', imgSrc);
            console.log('IMG DIM --------', JSON.stringify(this.imgDim));

            console.log('1 INITIAL SET 1 - FONT --------', this.oneCharFont1);
            console.log('1 INITIAL SET 2 - FONT --------', this.oneCharFont2);
            console.log('SYMBOLS - FONT SIZE --------', this.symbolsFontSize);

        } else if (this.config.general[0] === 'c3') {
            if (options.initials) {
                this.threeCharFont = options.initials["font-size"] + "px " + options.initials["font-family"];
                this.threeCharFontSize = options.initials["font-size"];
                this.monogramFontSize = (monogram ? options.monogram["font-size"] : 10) + "px";
            }

            console.log('AREA DATA --------', JSON.stringify(this.areaData));
            console.log('IMG POS --------', imgSrc);
            console.log('IMG DIM --------', JSON.stringify(this.imgDim));

            console.log('3 INITIALS - FONT --------', this.threeCharFont);
            console.log('SYMBOLS - FONT SIZE --------', this.symbolsFontSize);
            console.log('MONOGRAM - FONT SIZE --------', this.monogramFontSize);
        } else {
            console.log("noCharConfig");
        }

        this.myCanvas = document.getElementById("myCanvas");
        this.ctx = this.myCanvas.getContext("2d");

        this.originalHeight = this.myCanvas.height;
        this.originalWidth = this.myCanvas.width;

        console.log('Apply Gold color');
        console.log(this.isGold);
        if (this.isGold) {
            console.log('Apply Gold color - 1');
            $('ul.engraving-symbols-list li button').addClass(function(index, currentClass) {
                return currentClass + '-GOLD';
            });
        }
        // Add div for error messages
        $("#error-container").after('<div id="errorDiv"><div id="mmError" class="error\"></div><div id="ddError" class="error"></div><div id="yyError" class="error"></div><div id="blankError" class="error"></div></div>');

    }
    //Init End

    inputLengthValidation(el) {
        let maxValue = $(el).attr('maxlength');
        let currentLength = $(el).val().length;
        let lengthField = document.createElement('div');
        if ($(el).next('.text-length').length) {
            $(el)
                .next('.text-length')
                .text(currentLength + '/' + maxValue);
        } else {
            $(el).after(lengthField);
            $(lengthField).addClass('text-length');
            $(el)
                .next('.text-length')
                .text(currentLength + '/' + maxValue);
        }
    }

    debugConfig() {
        console.log('ENGRAVING CLASS CONFIG:----------------------------------');
        console.log(JSON.stringify(this.config));
        console.log('----------------------------------------------------------');
    }

render(char, font, type) {
    console.log('Render');

    // Get the canvas dimensions based on object fit logic
    let dimensions = this.getObjectFitSize(
        true,
        this.myCanvas.clientWidth,
        this.myCanvas.clientHeight,
        this.myCanvas.width,
        this.myCanvas.height
    );

    const dpr = window.devicePixelRatio || 1;
    
    // Set the canvas size multiplied by the device pixel ratio
    this.myCanvas.width = dimensions.width * dpr;
    this.myCanvas.height = dimensions.height * dpr;

    // Set up the context for drawing
    let text = char;
    let renderedChar;
    this.ctx.font = font;
    console.log("CONTEXT  ---   ",font);

    // Scale the canvas based on the ratio and device pixel ratio
    let ratio = Math.min(
        this.myCanvas.clientWidth / this.originalWidth,
        this.myCanvas.clientHeight / this.originalHeight
    );
    this.ctx.scale(ratio * dpr, ratio * dpr); // This handles scaling for both mobile and desktop
    
    this.ctx.textAlign = "center"; // Center the text horizontally
    this.ctx.textBaseline = "alphabetic"; // We'll handle vertical centering manually
    
    // Set the text color
    this.ctx.fillStyle = this.isGold ? "#e1be7e" : "#000000";
  
    
    // Decide the rendered character based on the type
    switch (type) {
        case 'monogram':
        case 'threeChar':
        case 'twelveChar':
        case 'phrase':
        case 'oneChar':
            renderedChar = text;
            console.log(`CHANGED TO ${type.toUpperCase()}`);
            break;
        default:
            renderedChar = "";
            console.log('DEFAULT');
            break;
    }

    // Measure the text dimensions
    let textMetrics = this.ctx.measureText(renderedChar);
    let textWidth = textMetrics.width;
    let textHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent;

    // Center positions
    let textX = this.areaData.x + this.areaData.width / 2;
    let textY = this.areaData.y + this.areaData.height / 2;

    // Adjust Y position based on text height to vertically center the text
    let centeredY = textY + (textMetrics.actualBoundingBoxAscent - textHeight / 2);

    // Render the text on the canvas
    this.ctx.fillText(renderedChar, textX, centeredY);

    console.log("render : renderedChar : ", renderedChar);
    console.log("render : ctx.font : ", this.ctx.font);
}

    jumpToCanvas() {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    // adapted from: https://www.npmjs.com/package/intrinsic-scale
    getObjectFitSize(
        contains /* true = contain, false = cover */,
        containerWidth,
        containerHeight,
        width,
        height
    ) {
        let doRatio = width / height;
        let cRatio = containerWidth / containerHeight;
        let targetWidth = 0;
        let targetHeight = 0;
        let test = contains ? doRatio > cRatio : doRatio < cRatio;

        if (test) {
            targetWidth = containerWidth;
            targetHeight = targetWidth / doRatio;
        } else {
            targetHeight = containerHeight;
            targetWidth = targetHeight * doRatio;
        }

        return {
            width: targetWidth,
            height: targetHeight,
            x: (containerWidth - targetWidth) / 2,
            y: (containerHeight - targetHeight) / 2
        };
    }

checkFontInput(buttonValue) {
    let obj = this;
    console.log("checkFontInput: buttonValue = ", buttonValue);

    // Get input text from both oneChar and nameChar fields
    let oneCharText = obj.oneCharInput.val() || obj.oneCharInput2.val();
    let nameCharText = obj.nameCharInput.val().toUpperCase();

    let oneCharFontStyle = '', nameCharFontStyle = '';
    const oneChar = "oneChar";
    const nameChar = "twelveChar";

     // Dynamic font size calculation for nameChar based on character length
    let adjustedFontSize;
    const maxFontSize = parseInt(obj.nameFontSize) + 16; // Max font size for <= 4 chars
    const minFontSize = parseInt(obj.nameFontSize); // Min font size for > 4 chars

    if (nameCharText.length <= 7) {
        adjustedFontSize = maxFontSize; // Full size for 4 or fewer chars
    } else {
        adjustedFontSize = minFontSize;
        // adjustedFontSize = Math.max(maxFontSize - ((nameCharText.length - 7) * 5), minFontSize);
    }


    // Determine font styles and text case for oneChar based on buttonValue
    switch (buttonValue) {
        case "Serif":
            oneCharText = oneCharText.toLowerCase();
            oneCharFontStyle = obj.oneCharFont1 + ' engraving-serif';
            break;
        case "Script":
            oneCharText = oneCharText.toUpperCase();
            oneCharFontStyle = obj.oneCharFont1 + ' engraving-script';
            break;
        case "Script-2":
            oneCharText = oneCharText.toUpperCase();
            oneCharFontStyle = obj.oneCharFont2 + ' engraving-script';
            buttonValue = "Script"; // Change for front-end
            break;
        case "Serif-2":
            oneCharText = oneCharText.toUpperCase();
            oneCharFontStyle = obj.oneCharFont2 + ' engraving-serif';
            buttonValue = "Serif"; // Change for front-end
            break;
        case "Sans-Serif":
            oneCharText = oneCharText.toUpperCase();
            oneCharFontStyle = `600 ${obj.oneCharFont2} Century Gothic`;
            buttonValue = "Sans-Serif";
            break;
        case "serif-caslon":
            nameCharFontStyle = `600 ${adjustedFontSize}px adobe-caslon-pro`;
            buttonValue = "Serif"; // Change for front-end
            obj.render(nameCharText, nameCharFontStyle, nameChar);
            break;
        case "script-sanvito":
            nameCharFontStyle = `600 ${adjustedFontSize + 12}px sanvito-pro`; // +13px adjustment
            buttonValue = "Script"; // Change for front-end
               obj.render(nameCharText, nameCharFontStyle, nameChar);
            break;
        default:
            console.log("Invalid button value.");
            break;
    }

 
    // Render nameChar or oneChar based on input text availability
    if (nameCharText !== "") {
      
        console.log("Rendering nameChar: ", nameCharText, nameCharFontStyle);
        obj.render(nameCharText, nameCharFontStyle, nameChar);
        this.insertEngravingValue(`Text-${nameCharText}-${buttonValue}`);
        obj.jumpToCanvas();

    } else if (oneCharText !== "") {
        console.log("Rendering oneChar: ", oneCharText, oneCharFontStyle);
        obj.render(oneCharText, oneCharFontStyle, oneChar);
        this.insertEngravingValue(`Text-${oneCharText}-${buttonValue}`);
        obj.jumpToCanvas();
    } else {
        if (nameCharText === "") {
            obj.ctx.clearRect(0, 0, 500, 500);
            this.insertEngravingValue("clear");
        }
        if (oneCharText === "") {
            obj.ctx.clearRect(0, 0, 500, 500);
            this.insertEngravingValue("clear");
        }
    }
}





    //Main events attachment
    attachEvents() {
        let obj = this;

        //Orig events start
        $('.length-validation').on('input', function () {
            obj.inputLengthValidation(this);
        });

        $('#add-engraving-mode').change(function () {
            if (this.checked == true) {
                $('.engraving-content').show();
            } else {
                $('.engraving-content').hide();
            }

            $('.engraving-options-list input[type=radio]').each(function () {
                let currentInput = $(this);

                if (currentInput.attr('checked') === 'checked') {
                    $('.engraving-container')
                        .find('.engraving-item[data-id=' + currentInput.attr('id') + ']')
                        .show();
                }
            });

            $('.length-validation').each(function () {
                obj.inputLengthValidation(this);
            });
        });
        //events
$('.engraving-options-list input[type=radio]').change(function () {
    $('#errorDiv .error').hide();
    
    let id = $(this).attr('id');  // Get the id of the selected option (NAME, SYMBOLS, etc.)
    let targetContainer = $(this).closest('.engraving-item-container').nextAll('.engraving-item-container');
    let target = targetContainer.find('.engraving-item[data-id=' + id + ']');
    
    obj.insertEngravingValue("clear");

    // Hide all engraving items initially
    $(targetContainer).find('.engraving-item').hide();

    if (this.checked == true) {
        // Show the selected engraving item (NAME or SYMBOLS)
        $(target).show();

        // Handle specific cases for NAME and SYMBOLS
        if (id === 'name') {
            // Show the 'Pick a Font' input for NAME
            $('div[data-id="name-input"] ul.engraving-options-list').find('li:first-child').addClass('active');
            $('div[data-id="name-input"]').show();  // Ensure NAME input is shown
        }

        let selected = $(target).find('input[type=radio]:checked');
        if ($(selected).length) {
            $('.engraving-container')
                .find('.engraving-item[data-id=' + $(selected).attr('id') + ']')
                .show();
        }
    }else {
                $(target).hide();
            }

   if (id === 'symbols') {
                $('.engraving-symbols-gallery:not(.slick-initialized)').slick({
                    speed: 300,
                    fade: true,
                    cssEase: 'linear',
                    accessibility: false,
                });

                $('.engraving-symbols-gallery').each(function () {
                    let slidesCounter = document.createElement('div');
                    let slides = $(this).find('.engraving-symbols-slide').length;
                    let currentSlideNum = $(this).find('.engraving-symbols-slide.slick-active').index();

                    if ($(this).next('.gallery-slides-counter').length) {
                    } else {
                        $(this).after(slidesCounter);
                        $(slidesCounter).addClass('gallery-slides-counter');
                        $(this)
                            .next('.gallery-slides-counter')
                            .text(currentSlideNum + 1 + '/' + slides);
                    }

                    $(this).on('afterChange', function (event, slick, currentSlide, nextSlide) {
                        $(this)
                            .next('.gallery-slides-counter')
                            .text(currentSlide + 1 + '/' + slides);
                    });
                });
            }
  
});


        $('.engraving-options-list button, .engraving-phrases button, .engraving-symbols-list button').on(
            'click touchstart',
            function (e) {
                console.log('Hide Test');
                $('#errorDiv .error').hide();
                e.preventDefault();
                $(this).closest('ul').find('li').removeClass('active');
                $(this).closest('li').addClass('active');
            }
        );
        //Orig events end

        $('#add-engraving-mode').on('change mouseup touchstart', function(){
            if(this.checked == true){
                console.log("ADD ENGRAVING CHANGE FUNCTION: IMAGE SRC", obj.engraving_product_img);
                $('#myCanvas').css('background-image', 'url(' + obj.engraving_product_img + ')');
                $( '.prod-large-img' ).hide();
                obj.myCanvas.style.display = "block";
                // obj.jumpToCanvas();
            }
                else {
                $( '.prod-large-img' ).show();
                obj.myCanvas.style.display = "none";
                $( '.prod-large-img' ).show();
                // obj.jumpToCanvas();
            }
        });

        $('.engraving-options-list input[type=radio][id=font]').change(function() {
            if(this.checked == true) {
                console.log("The FONT button is checked");
                $('div[data-id="font"] ul.engraving-options-list').find('li').removeClass('active');
                $('div[data-id="font"] ul.engraving-options-list').find('li:first-child').addClass('active');
            } else {
                console.log("The FONT button is not checked");
            }
        });
        $('.engraving-options-list input[type=radio][id=font-2]').change(function() {
            if(this.checked == true) {
                $('div[data-id="font-2"] ul.engraving-options-list').find('li').removeClass('active');
                   console.log("The FONT 2 button is checked");
                $('div[data-id="font-2"] ul.engraving-options-list').find('li:first-child').addClass('active');
            } else {
                console.log("The FONT 2 button is not checked");
            }
        });
              $('.engraving-options-list input[type=radio][id=name]').change(function() {
            if(this.checked == true) {
                $('div[data-id="name-input"] ul.engraving-options-list').find('li').removeClass('active');
                   console.log("The Name button is checked");
                $('div[data-id="name-input"] ul.engraving-options-list').find('li:first-child').addClass('active');
            } else {
                console.log("The Name button is not checked");
            }
        });

        let sdj = $('div[data-id="sdj"] input.length-validation');
        let monogramChar = $('div[data-id="sdj-custom"] input.length-validation');
        // let name = $('div[data-id="name-input"] input.length-validation');

        let s_Heart_r = $('div[data-id="s♥r"]');
        let s_Heart = $('div[data-id="s♥r"] input').eq(0);
        let r_Heart = $('div[data-id="s♥r"] input').eq(1);

        let s_And_j = $('div[data-id="s-and-j"]');
        let s_And = $('div[data-id="s-and-j"] input').eq(0);
        let j_And = $('div[data-id="s-and-j"] input').eq(1);

        let s_Plus_j = $('div[data-id="s-plus-j"]');
        let s_Plus = $('div[data-id="s-plus-j"] input').eq(0);
        let j_Plus = $('div[data-id="s-plus-j"] input').eq(1);

        let datesInput = $('div[data-id="dates"]');
        let dates1 = $('div[data-id="dates"] input').eq(0);
        let dates2 = $('div[data-id="dates"] input').eq(1);
        let dates3 = $('div[data-id="dates"] input').eq(2);

        let phraseBtn = $('.engraving-phrases li button');
      


        this.oneCharInput = $('div[data-id="font"] input.length-validation');
        this.oneCharInput2 = $('div[data-id="font-2"] input.length-validation');
        this.nameCharInput = $('div[data-id="name-input"] input.length-validation');
        const fontBtn = $('div[data-id="font"] ul.engraving-options-list li button');
        const fontBtn2 = $('div[data-id="font-2"] ul.engraving-options-list li button');
        const namefontBtn = $('div[data-id="name-input"] ul.engraving-options-list li button');
        let buttonValue = fontBtn.filter('.active').val();
        let buttonValue2 = fontBtn2.filter('.active').val();
        let buttonValueName = namefontBtn.filter('.active').val();

        fontBtn.on('mouseup touchstart', function() {
            console.log("fontBtn: mouseup/touchstart event");
            buttonValue = $(this).val();
            console.log("fontBtn: buttonValue = ", buttonValue);
            fontBtn.removeClass('active');
            $(this).addClass('active');
            obj.checkFontInput(buttonValue);
        });
         fontBtn2.on('mouseup touchstart', function() {
            console.log("fontBtn: mouseup/touchstart event");
            buttonValue2 = $(this).val();
            console.log("fontBtn: buttonValue = ", buttonValue2);
            fontBtn2.removeClass('active');
            $(this).addClass('active');
            obj.checkFontInput(buttonValue2);
        });

            namefontBtn.on('mouseup touchstart', function() {
            console.log("fontBtn: mouseup/touchstart event");
            buttonValueName = $(this).val();
            console.log("namefontBtn : buttonValue = ", buttonValueName);
            namefontBtn.removeClass('active');
            $(this).addClass('active');
            obj.checkFontInput(buttonValueName);
        });

        // this.nameCharInput.on('keyup', function () {
        //     console.log("nameCharInput: keyup event");
        //     const activeNameFontBtn = $('div[data-id="name-input"] ul.engraving-options-list li.active button');
        //     console.log("nameCharInput: activeFontBtn = ", activeNameFontBtn);
        //     const buttonValueName = activeNameFontBtn.val();
        //     console.log("nameCharInput: buttonValue = ", buttonValueName);
        //     obj.checkFontInput(buttonValueName);
        // });

this.nameCharInput.on('keyup', function () {
    console.log("nameCharInput: keyup event");
    const activeNameFontBtn = $('div[data-id="name-input"] ul.engraving-options-list li.active button');
    console.log("nameCharInput: activeFontBtn = ", activeNameFontBtn);
    const buttonValueName = activeNameFontBtn.val();
    console.log("nameCharInput: buttonValue = ", buttonValueName);

    let nameText = $(this).val().toUpperCase();
    let nameChar = "twelveChar";

    // Adjust font size dynamically based on character count
    let adjustedFontSize;
    const maxFontSize = parseInt(obj.nameFontSize) + 16;  // Maximum font size for fewer characters
    const minFontSize = parseInt(obj.nameFontSize) - 0;  // Minimum font size for more characters

    if (nameText.length <= 7) {
        adjustedFontSize = maxFontSize;  // Full size for 7 or fewer characters
    } else {
        // adjustedFontSize = maxFontSize - ((nameText.length - 7) * 5);  // Decrease size as characters increase
        // if (adjustedFontSize < minFontSize) {
            adjustedFontSize = minFontSize;  // Ensure it doesn't shrink below the minimum size
        // }
    }

    let adjustedFont;
    
    // Apply a 10px increase for Sanvito
    if (buttonValueName === 'script-sanvito') {
        // Use Sanvito with a 10px larger size to compensate
        adjustedFont = `600 ${adjustedFontSize + 12}px sanvito-pro`;
        buttonValue = 'Script';
    } else if (buttonValueName === 'serif-caslon') {
        // Use Caslon Pro for Serif button with the original size
        adjustedFont = `600 ${adjustedFontSize}px adobe-caslon-pro`;
       buttonValue = 'Serif';
    } else {
        // Default to original font family if no valid option is selected
        adjustedFont = `${adjustedFontSize}px ${obj.nameFont.split(" ")[1]}`;
    }
           obj.ctx.clearRect(0, 0, 500, 500);
    // Render the adjusted text
    obj.render(nameText, adjustedFont, nameChar);

    // Handle engraving input insertion
    if (nameText !== "") {
        setTimeout(() => {
            obj.jumpToCanvas();  // Jump to the canvas
        }, 1000);
        // obj.insertEngravingValue(nameText);
        obj.insertEngravingValue(`Text-${nameText}-${buttonValue}`);
    } else {
        obj.insertEngravingValue("clear");
    }
});


      
        this.oneCharInput.on('keyup', function () {
            console.log("oneCharInput: keyup event");
            const activeFontBtn = $('div[data-id="font"] ul.engraving-options-list li.active button');
            console.log("oneCharInput: activeFontBtn = ", activeFontBtn);
            const buttonValue = activeFontBtn.val();
            console.log("oneCharInput: buttonValue = ", buttonValue);
            obj.checkFontInput(buttonValue);
        });

          this.oneCharInput2.on('keyup', function () {
          console.log("oneCharInput: keyup event");
          const activeFontBtn2 = $('div[data-id="font-2"] ul.engraving-options-list li.active button');
          console.log("oneCharInput: activeFontBtn = ", activeFontBtn2);
          const buttonValue2 = activeFontBtn2.val();
          console.log("oneCharInput: buttonValue = ", buttonValue2);
          obj.checkFontInput(buttonValue2);
      });

      sdj.on('keyup', function () {
        let sdjText = $(this).val().toUpperCase();
        let threeChar = "threeChar";
    
        // Adjust font size based on the number of characters
        let adjustedFontSize;
        let fontFamily = obj.config.options.initials['font-family'] || 'default-font';
        let fontStyle = '';
        let fontWeight = '500';
    
        // Set initial font size based on character length and font family
        if (sdjText.length === 1 && fontFamily === 'engraving-regular') {
            adjustedFontSize = parseInt(obj.threeCharFontSize) + 55;
        } else if (sdjText.length === 1) {
            adjustedFontSize = parseInt(obj.threeCharFontSize) + 16;
        } else if (sdjText.length === 2 && fontFamily === 'engraving-regular') {
            adjustedFontSize = parseInt(obj.threeCharFontSize) + 18;
        } else if (sdjText.length === 2) {
            adjustedFontSize = parseInt(obj.threeCharFontSize) + 10;
        } else {
            adjustedFontSize = parseInt(obj.threeCharFontSize) + 2;
        }
    
        // Override font family if needed
        if (fontFamily === 'engraving-regular') {
            fontFamily = 'adobe-caslon-pro';
        } else if (fontFamily === 'engraving-semibolditalic') {
            fontFamily = 'adobe-caslon-pro';  // Change the family to adobe-caslon-pro
            fontStyle = 'italic';  // Set italic style for engraving-semibolditalic
            fontWeight = '600';
        }
    
        // Define the font string
        let adjustedFont = `${fontStyle} ${fontWeight} ${adjustedFontSize}px ${fontFamily}`;
        
        // Define the predefined area for fitting the text
        let predefinedArea = {
            width: obj.areaData.width,
            height: obj.areaData.height
        };
    
        // Wait for all fonts to be loaded before rendering
        document.fonts.ready.then(function() {
            // Set the font and measure the text
            obj.ctx.font = adjustedFont;
            let textMetrics = obj.ctx.measureText(sdjText);
            let textWidth = textMetrics.width;
            let textHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent;
    
            // Ensure the font size fits within the predefined area
            while (textWidth > predefinedArea.width || textHeight > predefinedArea.height) {
                if (sdjText.length === 1) {
                    adjustedFontSize -= 6;
                } else if (sdjText.length === 2) {
                    adjustedFontSize -= 8;
                } else {
                    adjustedFontSize -= 2;
                }
    
                // Update the font string after adjusting the size
                adjustedFont = `${fontStyle} ${fontWeight} ${adjustedFontSize}px ${fontFamily}`;
                obj.ctx.font = adjustedFont;
                textMetrics = obj.ctx.measureText(sdjText);
                textWidth = textMetrics.width;
                textHeight = textMetrics.actualBoundingBoxAscent + textMetrics.actualBoundingBoxDescent;
            }
    
            // Render the text with the final adjusted font size
            obj.render(sdjText, adjustedFont, threeChar);
    
            if (sdjText !== "") {
                setTimeout(() => {
                    obj.jumpToCanvas();
                }, 1000);
                obj.insertEngravingValue(sdjText);
            } else {
                obj.insertEngravingValue("clear");
            }
        });
    });
    
    
    
    




        monogramChar.on('keyup', function () {
            let inputValue = $(this).val();
            let monogramFontSize = (parseInt(obj.monogramFontSize) + 16);
            console.log("Monogram----");
            console.log(monogramFontSize);
            let monogramFont = `${monogramFontSize}px engraving-monogram`;
            var monogramText = inputValue.charAt(0).toLowerCase() + inputValue.charAt(1).toUpperCase() + inputValue.charAt(2).toLowerCase();
            let monogram = "monogram";
            obj.render(monogramText, monogramFont, monogram);
            if (monogramText !== ""){
                obj.insertEngravingValue(monogramText);
                setTimeout(() => {
                    obj.jumpToCanvas();
                }, 1500);
            }else {
                obj.insertEngravingValue("clear");
            }
            
        })

        
        s_Heart_r.on('keyup', () => { 
            let initialsFontFamily = obj.config.options.initials["font-family"] || 'engraving-regular';
        
            console.log('INITIALS FONT FAMILY:', initialsFontFamily);
        
            // Call buildHeart with selective arguments
            this.buildHeart(s_Heart.val(), r_Heart.val(), undefined, undefined, initialsFontFamily);
        });
        

        s_And_j.on('keyup', function () {
            let s_And_jText = (s_And.val().toUpperCase() || " ") + " & " + (j_And.val().toUpperCase() || " ");
            let threeChar = "threeChar";
            console.log(s_And_jText);
        
            obj.ctx.clearRect(0, 0, 500, 500);
        
            // Get the font family from config options and default to a value if not set
            let fontFamily = obj.config.options.initials['font-family'] || 'default-font';
            let fontStyle = '';
            let fontWeight = '500';
            let reducedFont = obj.threeCharFontSize;
            let ampersandFont = parseFloat(reducedFont) - parseFloat(4);
        
            // Assign font family and styles based on conditions
            if (fontFamily === 'engraving-regular') {
                fontFamily = 'adobe-caslon-pro';
            } else if (fontFamily === 'engraving-semibolditalic') {
                fontFamily = 'adobe-caslon-pro'; // Change the family to adobe-caslon-pro
                fontStyle = 'italic'; // Set italic style for engraving-semibolditalic
                fontWeight = '600';
            }
        
            // Create the fonts array for rendering
            const fonts = [
                `${fontStyle} ${fontWeight} ${reducedFont}px ${fontFamily}`,  // Custom font for initials
                `${ampersandFont}px adobe-caslon-pro`,  // Ampersand symbol font
                `${ampersandFont}px adobe-caslon-pro`,  // Ampersand symbol font fallback
                `${ampersandFont}px adobe-caslon-pro`,  // Ampersand symbol font again
                `${fontStyle} ${fontWeight} ${reducedFont}px ${fontFamily}`  // Custom font for initials again
            ];
        
            console.log(fonts);
        
            let x = obj.areaData.x + obj.areaData.width / 2 - (7.75 + Math.round(reducedFont / 1.5));
            let y = obj.areaData.y + obj.areaData.height / 2;
        
            // Wait for fonts to load before rendering
            document.fonts.ready.then(function () {
                const chars = s_And_jText.split("");
        
                for (let i = 0; i < chars.length; i++) {
                    const charNew = chars[i];
                    const font = fonts[i % fonts.length]; // Cycle through fonts array
                    obj.ctx.font = font;
                    obj.ctx.textAlign = "center";
                    obj.ctx.textBaseline = "middle";
        
                    obj.ctx.fillText(charNew, x, y);
                    let charWidth = obj.ctx.measureText(charNew).width;
                    console.log("MEASURE TEXT VALUE", obj.ctx.measureText(charNew).width);
                    x += 2 + Math.round(reducedFont / 2.5);
                }
        
                if (s_And_jText !== "") {
                    obj.insertEngravingValue(s_And_jText);
                    // Check if string contains at least 3 non-whitespace characters and jump
                    if (s_And_jText.replace(/\s/g, '').length === 3) {
                        obj.jumpToCanvas();
                    }
                } else {
                    obj.insertEngravingValue("clear");
                }
            });
        });
        

        s_Plus_j.on('keyup', function () {
            let s_Plus_jText = (s_Plus.val().toUpperCase() || " ") + " + " + (j_Plus.val().toUpperCase() || " ");
            let threeChar = "threeChar";
        
            // Define the font variables
            let fontFamily = obj.config.options.initials['font-family'] || 'default-font';
            let fontStyle = '';
            let fontWeight = '500';
            let adjustedFontSize = obj.threeCharFontSize;
        
            // Override font family if needed
            if (fontFamily === 'engraving-regular') {
                fontFamily = 'adobe-caslon-pro';
            } else if (fontFamily === 'engraving-semibolditalic') {
                fontFamily = 'adobe-caslon-pro';  // Change the family to adobe-caslon-pro
                fontStyle = 'italic';  // Set italic style for engraving-semibolditalic
                fontWeight = '600';
            }
        
            // Define the final font style
            let adjustedFont = `${fontStyle} ${fontWeight} ${adjustedFontSize}px ${fontFamily}`;
        
            // Wait for the fonts to be fully loaded before rendering
            document.fonts.ready.then(function() {
                // Render the text after the fonts are loaded
                obj.render(s_Plus_jText, adjustedFont, threeChar);
        
                // Handle engraving value insertion and canvas jump logic
                if (s_Plus_jText !== "") {
                    obj.insertEngravingValue(s_Plus_jText);
                    // Check if string contains at least 3 non-whitespace characters and jump to canvas
                    if (s_Plus_jText.replace(/\s/g, '').length === 3) {
                        obj.jumpToCanvas();
                    }
                } else {
                    obj.insertEngravingValue("clear");
                }
            });
        });
        

        datesInput.on('keyup', function () {
            var mm = dates1.val();
            var dd = dates2.val();
            var yy = dates3.val();
            var mmError = $("#mmError");
            var ddError = $("#ddError");
            var yyError = $("#yyError");
            var blankError = $("#blankError");
            var isValid = true;

            // Validate MM input
            if (/^\d{1,2}$/.test(mm) && mm > 0 && mm <= 12) {
                mm = mm + '.';
                mmError.hide();
            } else {
                if (mm === '') {
                    mmError.hide();
                } else {
                    if ($('#errorDiv .error:visible').length == 0) {
                        mmError.show().text("Enter date in MM.DD.YY format.");
                    }
                    isValid = false;
                    dates1.val('');
                }
            }

            // Validate DD input
            if (/^\d{1,2}$/.test(dd) && dd > 0 && dd <= 31) {
                dd = dd + '.';
                ddError.hide();
            } else {
                if (dd === '') {
                    ddError.hide();
                } else {
                    if ($('#errorDiv .error:visible').length == 0) {
                        ddError.show().text("Enter date in MM.DD.YY format.");
                    }
                    isValid = false;
                    dates2.val('');
                }
            }

            // Validate YY input
            if (/^\d{1,2}$/.test(yy)) {
                yy = yy.padStart(2, '0');
                yyError.hide();
            } else {
                if (yy === '') {
                    yyError.hide();
                } else {
                    if ($('#errorDiv .error:visible').length == 0) {
                        yyError.show().text("Enter date in MM.DD.YY format.");
                    }
                    isValid = false;
                    dates3.val('');
                }
            }

            // Validate for blank input
            if (dd === '' || mm === '' || yy === '') {
                isValid = false;
                if ($('#errorDiv .error:visible').length == 0) {
                    blankError.show().text("Enter date in MM.DD.YY format.");
                }
            } else {
                blankError.hide();
            }

            // Export datesText if input is valid
            if (isValid) {
                let datesText = mm + dd + yy;
                let threeChar = "threeChar";
                console.log('datesText');
                console.log(datesText);
            
                // Get the font family from config options and default to a value if not set
                let fontFamily = obj.config.options.dates['font-family'] || 'default-font';
                let fontSize = obj.config.options.dates["font-size"];
                let fontStyle = '';
                let fontWeight = '500';
            
                // Assign font family and styles based on conditions
                if (fontFamily === 'engraving-regular') {
                    fontFamily = 'adobe-caslon-pro';
                } else if (fontFamily === 'engraving-semibolditalic') {
                    fontFamily = 'adobe-caslon-pro'; // Change the family to adobe-caslon-pro
                    fontStyle = 'italic'; // Set italic style for engraving-semibolditalic
                    fontWeight = '600';
                }
            
                // Create the font for rendering
                let datesFont = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
            
                // Wait for fonts to load before rendering
                document.fonts.ready.then(function() {
                    // Render the datesText using the font after fonts are loaded
                    obj.render(datesText, datesFont, threeChar);
            
                    if (datesText !== "") {
               
                        // Jump to canvas if datesText has 5 or more characters
                        if (datesText.length >= 5) {
                            obj.insertEngravingValue(datesText);
                            setTimeout(() => {
                                obj.jumpToCanvas();
                            }, 1000);
                        }
                    } else {
                        obj.insertEngravingValue("clear");
                    }
                });
            }
            
        });

        // Restrict input to letters and numbers
        $(".length-validation").on("input", function() {
            var blankError = $("#blankError");
            var regex = /[^a-zA-Z]/g;
            if ($(this).val().match(regex)) {
                $(this).val($(this).val().replace(regex, ''));
                $("#blankError").show().text("Only letters are allowed.");
                obj.inputLengthValidation($(this));
            } else {
                $("#blankError").hide();
            }
        });

        $(".text-input").on("keyup", function() {
            var blankError = $("#blankError");
            var regex = /[^a-zA-Z]/g;
            if ($(this).val().match(regex)) {
                $(this).val($(this).val().replace(regex, ''));
                $("#blankError").show().text("Only letters are allowed.");
            } else {
                $("#blankError").hide();
            }
        });

        
        phraseBtn.on('mouseup touchend', function () {
            let phraseText;
            let buttonValue = $(this).val();
        
            if (buttonValue === "I&#x2665U") {
                // Use obj.phraseFont and obj.initialsFont directly instead of accessing obj.options
                let phraseFont = obj.phraseFont || 'engraving-regular';
           
                return obj.buildHeart("I", "U", true, phraseFont);
            } else {
                phraseText = buttonValue;
            }
            console.log(buttonValue);
            
            let phrase = "phrase";  // Declare the phrase variable
            
            // Continue using obj.phraseFont directly in the rest of your logic
            let fontFamily = obj.phraseFont || 'default-font';
            
            let fontStyle = 'normal';
            let fontWeight = '500';
            
            if (fontFamily.includes('engraving-regular')) {
                fontFamily = fontFamily.replace('engraving-regular', 'adobe-caslon-pro');
            } else if (fontFamily.includes('engraving-semibolditalic')) {
                fontFamily = fontFamily.replace('engraving-semibolditalic', 'adobe-caslon-pro');
                fontStyle = 'italic';
                fontWeight = '600';
            }
        
            let finalFont = `${fontStyle} ${fontWeight} ${fontFamily}`;
        
            // Render the text using the selected phrase and the adjusted font
            obj.render(phraseText, finalFont, phrase);
        
            if (phraseText !== "") {
                obj.insertEngravingValue("Phrase-" + phraseText);
                obj.jumpToCanvas();
            } else {
                obj.insertEngravingValue("clear");
            }
        });
        
        

        //CLEAR ALL INPUTS AND RENDER BLANK CANVAS WHEN CHANGING OPTIONS
        $('.engraving-options-list input[type=radio]').change(function(){
            $("#blankError").hide();
            let id = $(this).attr("id");
            let targetContainer = $(this).closest(".engraving-item-container").nextAll(".engraving-item-container");
            let target = targetContainer.find('.engraving-item[data-id=' + id + ']');
            $(targetContainer).find('.engraving-input-container input').val("");
            //reset counters
            $('.length-validation').each(function() {
               //console.log('Reset Length');
               //console.log(this);
               obj.inputLengthValidation($(this));
            });
            obj.render();
            target.find(".engraving-input-container input").each(function() {
                $(this).val("");
                obj.render();
                //console.log($(this).val());
            })
        });

        // var symbolImages = {};
        // var currentSymbolImg;

        // // Loop through each button in the engraving-symbols-list
        // $(".engraving-symbols-list button").each(function() {
        //     // Get the value attribute of the button
        //     var symbolValue = $(this).attr("value");
        //     var bgImage = $(this).find("span").css("background-image");
        //     // Remove the url() and quotes from the background-image string
        //     bgImage = bgImage.replace('url(','').replace(')','').replace(/\"/gi, "");
        //     // Add the image source to the symbolImages object
        //     symbolImages[symbolValue] = bgImage;
        // });
        // console.log('Symbol Images');
        // console.log(symbolImages);
        // const symbolsBtn = $(".engraving-symbols-list button");

        // // When a button is clicked, clear the previous image and draw the corresponding symbol onto the canvas
        // symbolsBtn.on('mouseup touchend',function(){
        //     console.log('Event listener triggered');
        //     console.log("IMG DIM WIDTH",obj.imgDim.width);
        //     // Get the value attribute of the clicked button
        //     var symbolValue = $(this).attr("value");
        //     console.log('SYMBOL VALUE of clicked',symbolValue);

        //     // Load the corresponding symbol image onto a new Image object
        //     var symbolImg = new Image();

        //     symbolImg.onload = function() {
        //         console.log("_____________CURRENT SYMBOL IMG",symbolImg);
        //         // Clear the canvas
        //         obj.ctx.clearRect(0, 0, 500, 500);
        //         // Draw the symbol onto the canvas at specified coordinates
        //         obj.ctx.drawImage(symbolImg,
        //             obj.areaData.x + obj.areaData.width / 2 - obj.imgDim.width/2,
        //             obj.areaData.y + obj.areaData.height / 2 - obj.imgDim.height/2, obj.imgDim.width, obj.imgDim.height
        //         );

        //         // Store the current symbol image
        //         currentSymbolImg = symbolImg;
        //     };
        //     console.log('Symb test:');
        //     console.log(symbolValue);
        //     let symbolValueOrig = symbolValue;
        //     if (symbolValue !== "") {
        //         if (symbolValue === 'STAR___CRESCENT'){ 
        //             symbolValue = "STAR & CRESCENT";}
        //         else {
        //             symbolValue = symbolValue.split('_').join(' ');
        //             console.log("OTHER THAN STAR AND CRESCENT");
        //         }
        //         obj.insertEngravingValue("SYMBOL-" + symbolValue);
        //         obj.jumpToCanvas();
        //     } else {
        //         obj.insertEngravingValue("clear");
        //     }
        //     // Set the dimensions of the image
        //     symbolImg.width = obj.imgDim.width;
        //     symbolImg.height = obj.imgDim.height;
        //     symbolImg.src = symbolImages[symbolValueOrig];
        // });

var symbolImages = {};
var currentSymbolImg;

// Loop through each button in the engraving-symbols-list
$(".engraving-symbols-list button").each(function() {
    // Get the value attribute of the button
    var symbolValue = $(this).attr("value");
    var bgImage = $(this).find("span").css("background-image");
    // Remove the url() and quotes from the background-image string
    bgImage = bgImage.replace('url(','').replace(')','').replace(/\"/gi, "");
    // Add the image source to the symbolImages object
    symbolImages[symbolValue] = bgImage;
});

console.log('Symbol Images');
console.log(symbolImages);
const symbolsBtn = $(".engraving-symbols-list button");

// When a button is clicked, clear the previous image and draw the corresponding symbol onto the canvas
symbolsBtn.on('mouseup touchend', function() {
    console.log('Event listener triggered');
    console.log("IMG DIM WIDTH", obj.imgDim.width);
    // Get the value attribute of the clicked button
    var symbolValue = $(this).attr("value");
    console.log('SYMBOL VALUE of clicked', symbolValue);

    // Load the corresponding symbol image onto a new Image object
    var symbolImg = new Image();

    symbolImg.onload = function() {
        console.log("_____________CURRENT SYMBOL IMG", symbolImg);

        // Clear the canvas
        obj.ctx.clearRect(0, 0, 500, 500); 
        obj.ctx.save(); // Save the current state of the canvas

        // Draw the symbol onto the canvas at specified coordinates
        obj.ctx.drawImage(symbolImg,
            obj.areaData.x + obj.areaData.width / 2 - obj.imgDim.width / 2,
            obj.areaData.y + obj.areaData.height / 2 - obj.imgDim.height / 2, 
            obj.imgDim.width, obj.imgDim.height
        );



        if (symbolImg.src.includes('GOLD') || symbolImg.src.includes('Gold')) {
        console.log('Applying gold color overlay to:', symbolImg.src);
        
        // Apply an exact color tint to match #ceb17e, #e1be7e
        obj.ctx.globalCompositeOperation = 'source-atop'; // Use source-atop to tint the symbol
        obj.ctx.fillStyle = '#e1be7e'; // Set the fill style to the desired color
  obj.ctx.fillRect(0, 0, 500, 500); // Fill the canvas with the tint
    } else {
        console.log('No gold overlay applied. Rendering default symbol.');
      // obj.ctx.fillRect(0, 0, 500, 500); // Fill the canvas with the tint
    }

 
        obj.ctx.restore(); // Restore the canvas state after drawing

        // Store the current symbol image
        currentSymbolImg = symbolImg;
    };

    console.log('Symb test:');
    console.log(symbolValue);
    let symbolValueOrig = symbolValue;
    if (symbolValue !== "") {
        if (symbolValue === 'STAR___CRESCENT') { 
            symbolValue = "STAR & CRESCENT";
        } else {
            symbolValue = symbolValue.split('_').join(' ');
            console.log("OTHER THAN STAR AND CRESCENT");
        }
        obj.insertEngravingValue("SYMBOL-" + symbolValue);
        obj.jumpToCanvas();
    } else {
        obj.insertEngravingValue("clear");
    }

    // Set the dimensions of the image
    symbolImg.width = obj.imgDim.width;
    symbolImg.height = obj.imgDim.height;
    symbolImg.src = symbolImages[symbolValueOrig];
});


    }

  insertEngravingValue(value) {
      if (value === "clear") {
          $("#engraving-prop").val("");
          $("#engraving-prop-aux").val("");
      } else {
          $("#engraving-prop").val(value.toString());
          $("#engraving-prop-aux").val('Final Sale');
      }
      console.log('>>> Engraving value set to:', value.toString());
  }

  buildHeart(lHeart, rHeart, isPhrase = false, phraseFont = 'engraving-regular', initialsFontFamily = 'engraving-regular') {
    let s_Heart_rText = (lHeart.toUpperCase() || " ") + " ♥ " + (rHeart.toUpperCase() || " ");
    this.ctx.clearRect(0, 0, 500, 500);

    // Split the string into individual characters for rendering
    const chars = s_Heart_rText.split("");

    // Determine font settings based on whether it’s a phrase or initials
    let baseFontSize = parseFloat(isPhrase ? this.phraseFont.split('px')[0] : this.threeCharFontSize); // Extract number only
    let fontFamily = isPhrase 
        ? this.phraseFont.split('px ')[1] 
        : initialsFontFamily;
    let fontStyle = '';
    let fontWeight = '500';

    if (fontFamily.includes('engraving-regular')) {
        fontFamily = fontFamily.replace('engraving-regular', 'adobe-caslon-pro');
    } else if (fontFamily.includes('engraving-semibolditalic')) {
        fontFamily = fontFamily.replace('engraving-semibolditalic', 'adobe-caslon-pro');
        fontStyle = 'italic';
        fontWeight = '600';
    }

    // Set specific font sizes for characters and the larger heart symbol
    const heartFontSize = baseFontSize + 3;  // Larger size for heart symbol
    const fonts = [
        `${fontStyle} ${fontWeight} ${baseFontSize}px ${fontFamily}`,  // Standard font for characters
        `${heartFontSize}px Arial`,                                     // Larger Arial font for heart symbol
        `${fontStyle} ${fontWeight} ${baseFontSize}px ${fontFamily}`
    ];

    const baseLines = ['middle', 'middle', 'middle'];
    let x = this.areaData.x + this.areaData.width / 2 - (7.2 + Math.round(baseFontSize / 1.5));
    let y = this.areaData.y + this.areaData.height / 2;

    this.ctx.textAlign = "center";
    const self = this;

    // Wait for fonts to load before rendering
    document.fonts.ready.then(function() {
        for (let i = 0; i < chars.length; i++) {
            const charNew = chars[i];
            const font = (charNew === "♥") ? fonts[1] : fonts[0];
            const baseLine = baseLines[i % baseLines.length];

            self.ctx.font = font;
            self.ctx.textBaseline = baseLine;

            // Apply Y-offset based on font size to center the larger heart
            let adjustedY = y;
            if (charNew === "♥") {
                adjustedY -= window.innerWidth < 768 ? baseFontSize * 0.20 : baseFontSize * 0.03; // Larger offset on mobile
            }

            self.ctx.fillText(charNew, x, adjustedY);
            x += 2.65 + Math.round(baseFontSize / 2.65);
        }

        if (s_Heart_rText !== "") {
            self.insertEngravingValue(s_Heart_rText);
            if (s_Heart_rText.replace(/\s/g, '').length === 3) {
                self.jumpToCanvas(); 
            }
        } else {
            self.insertEngravingValue("clear");
        }
    });
}






}
